"use client";

import React, { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
      if (menuOpen) setMenuOpen(false);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-700 ${
        scrolled || menuOpen
          ? 'py-3 bg-[rgba(3,8,16,0.96)] backdrop-blur-xl border-b border-[rgba(0,212,200,0.07)]'
          : 'py-5 md:py-7 bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-12 flex items-center justify-between">
        {/* Logo */}
        <Link href="#" className="flex items-center gap-3 group" aria-label="Pelagic Robotics home">
          <Image
            src="/assets/images/pelagic_logo_noTM_tealglow_2048-1773541232731.png"
            alt="Pelagic Robotics logo"
            width={211}
            height={70}
            className="h-[52px] md:h-[70px] w-auto object-contain"
            priority
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10" aria-label="Main navigation">
          <a href="#about" className="nav-link">About</a>
          <a href="#contact" className="nav-link">Contact</a>
        </nav>

        {/* Desktop CTA */}
        <a
          href="mailto:info@pelagicrobotics.io"
          className="hidden md:inline-flex items-center gap-2 text-[0.65rem] font-semibold uppercase tracking-[0.2em] border border-[rgba(0,212,200,0.35)] text-[#00D4C8] px-5 py-2.5 transition-all duration-300 hover:bg-[rgba(0,212,200,0.08)] hover:border-[rgba(0,212,200,0.6)]"
          style={{ letterSpacing: '0.18em' }}
        >
          Enquire
        </a>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col justify-center items-center gap-[5px] w-9 h-9 focus:outline-none"
          onClick={() => setMenuOpen(o => !o)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span
            className="block w-5 h-px transition-all duration-300"
            style={{
              background: 'var(--teal-glow)',
              transform: menuOpen ? 'translateY(6px) rotate(45deg)' : 'none',
            }}
          />
          <span
            className="block w-5 h-px transition-all duration-300"
            style={{
              background: 'var(--teal-glow)',
              opacity: menuOpen ? 0 : 1,
            }}
          />
          <span
            className="block w-5 h-px transition-all duration-300"
            style={{
              background: 'var(--teal-glow)',
              transform: menuOpen ? 'translateY(-6px) rotate(-45deg)' : 'none',
            }}
          />
        </button>
      </div>
      {/* Mobile nav drawer */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${menuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`}
        style={{ background: 'rgba(3,8,16,0.98)', borderTop: menuOpen ? '1px solid rgba(0,212,200,0.07)' : 'none' }}
      >
        <nav className="flex flex-col px-5 py-5 gap-1" aria-label="Mobile navigation">
          {[
            { href: '#about', label: 'About' },
            { href: '#contact', label: 'Contact' },
          ]?.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              onClick={closeMenu}
              className="py-3 border-b border-[rgba(0,212,200,0.06)] text-[0.7rem] font-medium uppercase tracking-[0.2em]"
              style={{ color: 'rgba(232,237,244,0.8)' }}
            >
              {label}
            </a>
          ))}
          <a
            href="mailto:info@pelagicrobotics.io"
            onClick={closeMenu}
            className="mt-4 flex items-center justify-center gap-2 py-3 border border-[rgba(0,212,200,0.35)] text-[#00D4C8] text-[0.65rem] font-semibold uppercase tracking-[0.18em]"
          >
            Enquire
          </a>
        </nav>
      </div>
    </header>
  );
}